var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12C1.09722 12 0.746528 11.8507 0.447917 11.5521C0.149306 11.2535 0 10.9028 0 10.5V1.5C0 1.09722 0.149306 0.746528 0.447917 0.447917C0.746528 0.149306 1.09722 0 1.5 0H14.5C14.9125 0 15.2656 0.149306 15.5594 0.447917C15.8531 0.746528 16 1.09722 16 1.5V10.5C16 10.9028 15.8531 11.2535 15.5594 11.5521C15.2656 11.8507 14.9125 12 14.5 12H1.5ZM14.5 3.27083L8.39583 6.77083C8.333 6.8125 8.26703 6.84375 8.19792 6.86458C8.12881 6.88542 8.06283 6.89583 8 6.89583C7.93056 6.89583 7.86806 6.88542 7.8125 6.86458C7.75694 6.84375 7.69501 6.81458 7.62671 6.77708L1.5 3.27083V10.5H14.5V3.27083ZM8 5.22917L14.4792 1.5H1.54167L8 5.22917ZM1.5 3.00198V3.18944V2.09375V2.10417V1.5V2.10317V2.09375V3.19121V3.00381V10.5V3.00198Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmail);
export default __webpack_public_path__ + "static/media/icon-email.ea539a130744669451a770aafa5da2d4.svg";
export { ForwardRef as ReactComponent };